import { getSearchData } from '@/lib/zhenApp'
const state = {
    // 类型
    showAll: false,
    cateId: '',
    tree: [],
    searchText: '',
    showOrderList: false,
    showFilterList: false
}

const getters = {
    getShowAll: state => {
        return state.showAll
    },
    getCateId: state => {
        return state.cateId
    },
    getTree: state => {
        return state.tree
    },
    getSearchText: state => {
        return state.searchText
    },
    getShowOrderList: state => {
        return state.showOrderList
    },
    getShowFilterList: state => {
        return state.showFilterList
    }
}

// 状态直接变
const mutations = {
    // 品牌
    changeShowAll(state, payload) {
        state.showAll = payload
    },
    changCateId(state, payload) {
        state.cateId = payload
    },
    changeTree(state, payload) {
        state.tree = payload
    },
    changeSearchText(state, payload) {
        state.searchText = payload
    },
    changeShowOrderList(state, payload) {
        state.showOrderList = payload
    },
    changeShowFilterList(state, payload) {
        state.showFilterList = payload
    },
    changTreeCheck(state, payload) {
        let _tree = JSON.parse(JSON.stringify(state.tree))
        let treeIndex = _tree[payload]
        treeIndex.checked = true
        state.tree = _tree
    }
}

// 异步
const actions = {
    fnGetShowAll({ commit, state }) {
        commit('changeShowAll', !state.showAll)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
